import { Button } from '../ui/button'
import { Link } from 'react-router-dom'

export function FinalCta() {
  return (
    <section className='border-t bg-muted/30'>
      <div className='mx-auto max-w-7xl px-4 py-12 text-center space-y-4'>
        <h3 className='text-2xl font-bold'>Prêt à essayer MOGESAPP ?</h3>
        <p className='text-muted-foreground'>
          Créez votre compte en 1 minute. C’est gratuit.
        </p>
        <Link to='/register?redirect=/dashboard'>
          <Button size='lg'>Commencer gratuitement</Button>
        </Link>
      </div>
    </section>
  )
}
